export default {
  subjectsSearch: {
    en: 'search',
    lt: 'paieska',
    ro: 'cuutare',
  },
  registracija: {
    en: 'registration',
    lt: 'registracija',
    ro: 'inregistrare',
  },
  login: {
    en: 'en/login',
    lt: 'prisijungti',
    ro: 'autentificare',
  },
  passwordReset: {
    en: 'password-reset',
    lt: 'pakeisti-slaptazodi',
    ro: 'reseteaza-parola',
  },
  passwordResetConfirmation: {
    en: 'password-reset-confirmation',
    lt: 'patvirtinti-slaptazodzio-pakeitima',
    ro: 'confirmarea-resetarii-parolei',
  },
  verifyEmail: {
    en: 'verify-email',
    lt: 'patvirtinti-elpasta',
    ro: 'verificati-email',
  },
  studentConfirmation: {
    en: 'student-confirmation',
    lt: 'mokinio-patvirtinimas',
    ro: 'confirmarea-studentului',
  },
  teacher: {
    en: 'en/teacher',
    lt: 'mokytojas',
    ro: 'profesori',
  },
  teachers: {
    en: 'en/teachers',
    lt: 'mokytojai-korepetitoriai-papildomas-mokymasis',
    ro: 'profesori',
  },
  homePage: {
    lt: '',
    en: 'en',
    ro: '',
  },
  notFound: {
    lt: '404',
    en: '404',
    ro: '404',
  },
  notAuthorized: {
    lt: '403',
    en: '403',
    ro: '403',
  },
  serverError: {
    lt: '500',
    en: '500',
    ro: '500',
  },
  energySmartStart: {
    lt: 'energysmartstart',
    en: 'en/energysmartstart',
    ro: 'ro/energysmartstart',
  },
  duk: {
    en: 'en/faq',
    lt: 'duk',
    ro: 'faq',
  },
  privacyPolicy: {
    en: 'privacy-policy',
    lt: 'privatumo-politika',
    ro: 'politica-de-confidentialitate',
  },
  siteRules: {
    en: 'terms-of-use',
    lt: 'naudojimosi-taisykles',
    ro: 'termeni-de-utilizare',
  },
  contractTerms: {
    en: 'tutoring-service-contract',
    lt: 'mokymo-paslaugu-teikimo-sutartis',
    ro: 'contracte-de-servicii',
  },
};
